// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { AbstractQueryParams, TypesaurusCoreDoc } from '@res/ngg-core';
import { IServerSideGetRowsRequest } from 'ag-grid-community';
import { StorageDef, StorageRef, StorageUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace StorageActions {
  export class GetAllStorage {
    static readonly type = '[Storage] GetAllStorage';
    readonly type = GetAllStorage.type;
  }

  export class InitStorages {
    static readonly type = '[Storage] InitStorages';
    readonly type = InitStorages.type;
  }

  export class CloseStoragesConnection {
    static readonly type = '[Storage] CloseStoragesConnection';
    readonly type = CloseStoragesConnection.type;
  }

  export class GetStorageById {
    static readonly type = '[Storage] GetStorageById';
    readonly type = GetStorageById.type;
  }

  export class UpdateStorage {
    static readonly type = '[Storage] UpdateStorage';
    constructor(
      public storageData: Partial<StorageUpdateData>,
      public ref: StorageRef,
    ) {}
  }

  export class UpdateStorageResult {
    static readonly type = '[Storage] UpdateStorageResult';
    constructor(public data: Array<TypesaurusCoreDoc<StorageDef> | null | undefined>) {}
  }

  export class DeleteStorage {
    static readonly type = '[Storage] DeleteStorage';
    readonly type = DeleteStorage.type;
  }

  export class AddStorageItem {
    static readonly type = '[Storage] AddStorageItem';
    constructor(public items: Array<StorageUpdateData>) {}
  }

  export class QueryStorage {
    static readonly type = '[Storage] QueryStorage';

    constructor(
      public filter: {
        query: AbstractQueryParams<StorageDef>[];
      },
    ) {}
  }

  export class PaginateQueryStorage {
    static readonly type = '[Storage] PaginateQueryStorage';
    constructor(
      public request: IServerSideGetRowsRequest,
      public isResetAfterFilterOrSort = false,
    ) {}
  }
  export class StorageError {
    static readonly type = '[Storage] StorageError';

    constructor(public error: Error) {}
  }
}
